import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles(theme => {
  return {
    generalChip: {
      background: grey[500],
      color: '#fff'
    }
  };
});

const GeneralChip = ({
  item,
  onDelete,
  isDelible = false
}) => {
  const classes = useStyles();

  const conditionalDelete = isDelible ? { onDelete } : {};

  return (
    <Chip
      {...conditionalDelete}
      className={classes.generalChip}
      size="small"
      // avatar={(
      //   <Avatar className={classes.coderAvatar}>
      //     <PersonIcon />
      //   </Avatar>
      // )}
      label={item.label}
    />
  );
};

GeneralChip.propTypes = {
  isDelible: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  item: PropTypes.shape({
    label: PropTypes.string
  }).isRequired
};

export default GeneralChip;
